module.exports = __webpack_public_path__ + "static/media/pro-1.b193139b.png";